import { Component } from '@angular/core';

@Component({
  selector: 'vf-spinner',
  template: `
    <div style="display: flex; height: 100%; width: 100%; background-color: #fff; position: fixed; top: 0; left: 0; z-index: 9999; align-items: center; justify-content: center;">
      <div style="display: flex; flex-direction: column; align-items: center; max-width: 20rem; width: 100%; padding: 0 1.5rem;">
        <div style="margin-bottom: 2.5rem;">
          <img src="https://cdn.trovve.com/trovve/login-left-logo.png" alt="Trovve"
            style="height: 2.25rem; object-fit: contain; opacity: 0.2;">
        </div>
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;">
          <p style="font-size: 1rem; color: rgb(31, 41, 55); text-align: center; margin: 0;">Getting things ready\u2026</p>
        </div>
        <div style="width: 100%;">
          <div style="height: 3px; background: rgb(229, 231, 235); border-radius: 9999px; overflow: hidden; position: relative;">
            <div class="loading-bar-slider"
              style="position: absolute; top: 0; bottom: 0; width: 50%; background: rgb(55, 65, 81); border-radius: 9999px;">
            </div>
          </div>
        </div>
      </div>
    </div>`
})
export class SpinnerComponent {
  constructor() { }
}
